import { useState, useEffect } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { FaInstagram } from 'react-icons/fa';
import 'react-circular-progressbar/dist/styles.css';
import './profilebasicinfo.css';
import axios from 'axios';
import api from '../../api/axios';
import { useTranslation } from 'react-i18next';

const genderMap = {
    "männlich": 1,
    "weiblich": 2,
    "divers": 3
};

const reverseGenderMap = {
    1: "männlich",
    2: "weiblich",
    3: "divers"
};

const infoText =
    '„Instagram“ und „Über mich“ werden in dem Event an deinem Tisch geteilt. ' +
    'Wenn du das nicht möchtest, dann lasse das jeweilige Feld leer.';

const ProfileBasicInfo = ({ onProgressChange, progressCount, maxCount }) => {

    const { t } = useTranslation();
    const [editable, setEditable] = useState(false);
    const [vorname, setVorname] = useState("");
    const [nachname, setNachname] = useState("");
    const [alter, setAlter] = useState("");
    const [email, setEmail] = useState("");
    const [geschlecht, setGeschlecht] = useState("");
    const [aboutme, setAboutMe] = useState("");
    const [profilbild, setProfilBild] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [instagramm, setInstagramm] = useState("");
    const [eventinfo, setEventinfo] = useState(false);

    const [selectedFile, setSelectedFile] = useState(null);
    const [userData, setUserData] = useState(null);
    const progressTotal = 100;

    useEffect(() => {
        const storedUser = JSON.parse(sessionStorage.getItem("userData"));
        if (!storedUser?.userid) return;

        api.post("/user/getuserprofile", {
            userid: storedUser.userid,
        })
            .then((res) => {
                const user = res.data;
                setVorname(user.vorname || "");
                setNachname(user.nachname || "");
                setAlter(user.alter || "");
                setEmail(user.email || "");
                setGeschlecht(reverseGenderMap[user.geschlecht] || "");
                setAboutMe(user.aboutme || "");
                setProfilBild(user.profilbild || "");
                setInstagramm(user.instagramm || "");
                setEventinfo(user.eventinfo || false);

                if (
                    (!reverseGenderMap[user.geschlecht] || reverseGenderMap[user.geschlecht] === "") &&
                    (!user.aboutme || user.aboutme.trim() === "")
                ) {
                    setEditable(true);
                } else {
                    setEditable(false);
                }
            })
            .catch((err) => {
                console.error("Error loading user profile:", err);
            });
    }, []);

    useEffect(() => {
        let filled = 0;
        let total = 2; // geschlecht, aboutme, profilbild

        //if (geschlecht?.trim()) filled++;
        if (aboutme?.trim()) filled++;
        if (profilbild) filled++;

        onProgressChange(filled, total); // call parent's handler
    }, [geschlecht, aboutme, profilbild]);

    const handleEditClick = () => {
        setEditable(!editable);
    };

    const handleAboutMeChange = (e) => {
        setAboutMe(e.target.value);
    };

    const handleInstagrammChange = (e) => {
        setInstagramm(e.target.value);
    };

    const handleSaveClick = () => {
        setEditable(false);
        // You can perform actions like saving the data to the backend here
        api.put(`/user/update`, { geschlecht: genderMap[geschlecht] || null, aboutme, instagramm, email: email, eventinfo }) // Send email along with other data
            .then(response => {
                console.log(response.data); // Log success message
                // You can add a success message or perform any other action here
            })
            .catch(error => {
                console.error('Error updating user information:', error);
                // Handle error, display error message, etc.
            });
    };

    const handleFileChange = async (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;

        const formData = new FormData();
        formData.append("profilbild", selectedFile);
        formData.append("email", email);

        try {
            const response = await api.post("/user/updateprofilepicture", formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });

            // Convert file to Base64 to instantly show it in UI
            const reader = new FileReader();
            reader.onloadend = () => {
                setProfilBild(reader.result);
            };
            reader.readAsDataURL(selectedFile);

            alert("Profile picture updated successfully!");
        } catch (error) {
            console.error("Error uploading profile picture:", error);
            alert("Upload failed");
        }
    };


    const InfoIcon = ({ text }) => (
        <span className="info-icon">
            ℹ️
            <span className="info-tooltip">{text}</span>
        </span>
    );

    return (
        <div className="profile-top">
            <div className="profile-picture">
                <img src={profilbild} />
                <div className={`profile-picture-overlay ${!profilbild ? "force-hover" : ""}`}>
                    <input
                        type="file"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                        id="fileInput"
                    />
                    <button
                        className="add-picture"
                        onClick={() => document.getElementById("fileInput").click()}
                    >
                        +
                    </button>
                </div>
            </div>
            <div className="profile-info">
                <h2>
                    {vorname} {nachname} ({alter})
                    <button className="edit-icon" onClick={handleEditClick} aria-label="Edit profile">
                        <svg xmlns="http://www.w3.org/2000/svg"
                            width="18" height="18" fill="currentColor"
                            viewBox="0 0 24 24">
                            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 
                                7.04a1.003 1.003 0 0 0 0-1.42l-2.34-2.34a1.003 
                                1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.82z"/>
                        </svg>
                    </button>
                </h2>
                <p>
                    <strong>
                        {t("EMailAddress")}
                    </strong>
                    {email}
                </p>
                <p>
                    <strong>
                        {t("Gender")}
                    </strong>
                    {editable ? (
                        <div className="modern-dropdown">
                            <button
                                className="dropdown-trigger"
                                onClick={() => setDropdownOpen(prev => !prev)}
                            >
                                {geschlecht || "-- wählen --"}
                                <span className="dropdown-arrow">▾</span>
                            </button>

                            {dropdownOpen && (
                                <div className="dropdown-menu">
                                    <div onClick={() => { setGeschlecht("männlich"); setDropdownOpen(false); }}>{t("Male")}</div>
                                    <div onClick={() => { setGeschlecht("weiblich"); setDropdownOpen(false); }}>{t("Female")}</div>
                                    <div onClick={() => { setGeschlecht("divers"); setDropdownOpen(false); }}>{t("Diverse")}</div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <span>{geschlecht}</span>
                    )}
                </p>
                <div className="profile-instagramm">
                    <h4 className="label-with-info">
                        <FaInstagram color="#000000" /> {t('Instagram')}
                        <InfoIcon text={infoText} />
                    </h4>
                    {editable ? (
                        <>
                            <textarea value={instagramm} onChange={handleInstagrammChange}></textarea>
                        </>
                    ) : (
                        <p>{instagramm}</p>
                    )}
                </div>
                <div className="profile-description">
                    <h4 className="label-with-info">
                        {t("AboutMe")}
                        <InfoIcon text={infoText} />
                    </h4>
                    {editable ? (
                        <>
                            <textarea value={aboutme} onChange={handleAboutMeChange}></textarea>
                            <button onClick={handleSaveClick}>{t("SaveProfileBasicInfo")}</button>
                        </>
                    ) : (
                        <p>{aboutme}</p>
                    )}
                </div>
                <label className={`profile-checkbox${!editable ? ' profile-checkbox-disabled' : ''}`}>
                    <input
                        type="checkbox"
                        checked={eventinfo}
                        disabled={!editable}
                        onChange={(e) => setEventinfo(e.target.checked)}
                    />
                    <span>Keine Event Infos erhalten via Mail</span>
                </label>
            </div>
            <div className="progress-container" aria-hidden="false">
                <div className="progress-card">
                    <CircularProgressbar
                        className="my-progressbar"
                        value={maxCount > 0 ? (progressCount / maxCount) * 100 : 0}
                        text={`${Math.round(maxCount > 0 ? (progressCount / maxCount) * 100 : 0)}%`}
                        strokeWidth={6}          /* <- control ring thickness */
                        styles={buildStyles({
                            // for gradient we still reference the id in the SVG defs below
                            pathColor: "url(#gradient)",
                            trailColor: "#eef1f6",
                            textColor: "#4b5563",
                            textSize: "14px",
                            strokeLinecap: "round",
                        })}
                    />
                    {/* gradient defs — must be present somewhere on the page */}
                    <svg className="progress-defs" aria-hidden="true">
                        <defs>
                            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#9fc5d8" />
                                <stop offset="100%" stopColor="#6a8fb6" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default ProfileBasicInfo;